import React from 'react';
import './administration.scss';
import Breadcrumb from '../../shared/breadcrumb/breadcrumb.js';
import Phone from './phone/phone.js';
import ResponsiveImage from 'shared/responsive-image/responsive-image';
import { useStore } from 'hooks/useStore';

export function Administration() {
  const {
    state: {
      administration: {
        workers
      }
    }
  } = useStore();

  return (
    <main>
      <Breadcrumb
        links={[
          { to: '/', text: 'Главная' },
          { to: '/administration', text: 'Администрация' }
        ]}
      />
      {/* /breadcrumb */}

      <div className="container margin_60">
        <div className="main_title">
          <h1>Администрация</h1>
          <p>Здесь представлена администрация диспансера.</p>
        </div>
        {workers.map(worker => (
          <div className="row" key={worker.name}>
            <div className="col-xl-12 col-lg-12">
              <div id="section_1">
                <div className="box_general_3">
                  <div className="profile">
                    <div className="row">
                      <div className="col-lg-5 col-md-4">
                        <figure>
                          {worker.image ? (
                            <ResponsiveImage
                              src={worker.image}
                              className="img-fluid mx-auto d-block"
                              alt={worker.name}
                              width={2360}
                              height={2776}
                            />
                          ) : (
                            <ResponsiveImage
                              src="/v1555156216/users/no-photo-doctor_640.png"
                              className="img-fluid mx-auto d-block"
                              alt={worker.name}
                              width={568}
                              height={640}
                            />
                          )}
                        </figure>
                      </div>
                      <div className="col-lg-7 col-md-8">
                        <small>{worker.position}</small>
                        <h1>{worker.name}</h1>
                        <ul className="statistic">
                          <li>{worker.position}</li>
                          {worker.rooms.map(room => (
                            <li key={room}>Кабинет № {room}</li>
                          ))}
                        </ul>
                        <ul className="contacts">
                          <li>
                            <h6>Email</h6>
                            {worker.email || 'не указан'}
                          </li>
                          <li>
                            <h6>Телефон</h6> <Phone phone={worker.phone} />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <hr />

                  {/* /profile */}
                  <div className="indent_title_in">
                    <i className="pe-7s-user" />
                    <h3>Характеристика</h3>
                    <p>Характеристика работника.</p>
                  </div>
                  <div className="wrapper_indent">
                    <p>{worker.description}</p>
                    <h6>Специализации</h6>
                    <div className="row">
                      <div className="col-lg-6">
                        <ul className="bullets">
                          {worker.specialities.map(speciality => (
                            <li key={speciality}>{speciality}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </main>
  );
}

export default Administration;
